/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-10-14 16:26:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 18:06:25
 */
import axios from 'axios'
export function worldJson(type, echarts, callback) {
    var log = function (msg) {
        if (typeof console !== 'undefined') {
            console && console.error && console.error(msg);
        }
    };
    const typeTranfrom = type.replace(' ', '_')

    const keys = [
      "./Afghanistan.json",
      "./Albania.json",
      "./Algeria.json",
      "./Andorra.json",
      "./Angola.json",
      "./Anguilla.json",
      "./Antigua_and_Barbuda.json",
      "./Argentina.json",
      "./Armenia.json",
      "./Australia.json",
      "./Austria.json",
      "./Azerbaijan.json",
      "./Bahrain.json",
      "./Bangladesh.json",
      "./Barbados.json",
      "./Belarus.json",
      "./Belgium.json",
      "./Belize.json",
      "./Benin.json",
      "./Bermuda.json",
      "./Bhutan.json",
      "./Bolivia.json",
      "./Bosnia_and_Herzegovina.json",
      "./Botswana.json",
      "./Brazil.json",
      "./British_Indian_Ocean_Territory.json",
      "./British_Virgin_Islands.json",
      "./Brunei.json",
      "./Bulgaria.json",
      "./Burkina_Faso.json",
      "./Burundi.json",
      "./Cambodia.json",
      "./Cameroon.json",
      "./Canada.json",
      "./Cape_Verde.json",
      "./Cayman_Islands.json",
      "./Central_African_Republic.json",
      "./Chad.json",
      "./Chile.json",
      "./China.json",
      "./Colombia.json",
      "./Comoros.json",
      "./Congo-Brazzaville.json",
      "./Congo-Kinshasa.json",
      "./Cook_Islands.json",
      "./Coral_Sea_Islands_Territory.json",
      "./Costa_Rica.json",
      "./Croatia.json",
      "./Cuba.json",
      "./Cyprus.json",
      "./Czechia.json",
      "./Denmark.json",
      "./Djibouti.json",
      "./Dominica.json",
      "./Dominican_Republic.json",
      "./East_Timor.json",
      "./Ecuador.json",
      "./Egypt.json",
      "./El_Salvador.json",
      "./Equatorial_Guinea.json",
      "./Eritrea.json",
      "./Estonia.json",
      "./Ethiopia.json",
      "./Falkland_Islands.json",
      "./Faroe_Islands.json",
      "./Federated_States_of_Micronesia.json",
      "./Fiji.json",
      "./Finland.json",
      "./France.json",
      "./Gabon.json",
      "./Georgia.json",
      "./Germany.json",
      "./Ghana.json",
      "./Gibraltar.json",
      "./Greece.json",
      "./Greenland.json",
      "./Guatemala.json",
      "./Guernsey.json",
      "./Guinea-Bissau.json",
      "./Guinea.json",
      "./Guyana.json",
      "./Haiti.json",
      "./Honduras.json",
      "./Hungary.json",
      "./Iceland.json",
      "./India.json",
      "./Indonesia.json",
      "./Iraq.json",
      "./Ireland.json",
      "./Islamic_Republic_of_Iran.json",
      "./Isle_of_Man.json",
      "./Israel.json",
      "./Italy.json",
      "./Jamaica.json",
      "./Japan.json",
      "./Jersey.json",
      "./Jordan.json",
      "./Juguang.json",
      "./Kazakhstan.json",
      "./Kenya.json",
      "./Kiribati.json",
      "./Kuwait.json",
      "./Kyrgyzstan.json",
      "./Laos.json",
      "./Latvia.json",
      "./Lebanon.json",
      "./Lesotho.json",
      "./Liberia.json",
      "./Libya.json",
      "./Liechtenstein.json",
      "./Lithuania.json",
      "./Luxemburg.json",
      "./Macedonia.json",
      "./Madagascar.json",
      "./Malawi.json",
      "./Malaysia.json",
      "./Maldives.json",
      "./Mali.json",
      "./Malta.json",
      "./Marshall_Islands.json",
      "./Mauritania.json",
      "./Mauritius.json",
      "./Mexico.json",
      "./Moldova.json",
      "./Monaco.json",
      "./Mongolia.json",
      "./Montenegro.json",
      "./Montserrat.json",
      "./Morocco.json",
      "./Mozambique.json",
      "./Myanmar.json",
      "./Namibia.json",
      "./Nepal.json",
      "./New_Zealand.json",
      "./Nicaragua.json",
      "./Niger.json",
      "./Nigeria.json",
      "./Niue.json",
      "./North_Korea.json",
      "./Norway.json",
      "./Oman.json",
      "./Pakistan.json",
      "./Palau.json",
      "./Palestine.json",
      "./Panama.json",
      "./Papua_New_Guinea.json",
      "./Paraguay.json",
      "./Peru.json",
      "./Philippines.json",
      "./Pitcairn_Islands.json",
      "./Poland.json",
      "./Portugal.json",
      "./Qatar.json",
      "./Republic_of_Kosovo.json",
      "./Romania.json",
      "./Russia.json",
      "./Russian_Federation.json",
      "./Rwanda.json",
      "./Sahrawi_Arab_Democratic_Republic.json",
      "./Saint_Helena_Ascension_and_Tristan_da_Cunha.json",
      "./Saint_Kitts_and_Nevis.json",
      "./Saint_Lucia.json",
      "./Saint_Vincent_and_the_Grenadines.json",
      "./Samoa.json",
      "./San_Marino.json",
      "./Saudi_Arabia.json",
      "./Senegal.json",
      "./Serbia.json",
      "./Seychelles.json",
      "./Sierra_Leone.json",
      "./Singapore.json",
      "./Slovakia.json",
      "./Slovenia.json",
      "./Solomon_Islands.json",
      "./Somalia.json",
      "./South_Africa.json",
      "./South_Georgia_and_the_South_Sandwich_Islands.json",
      "./South_Korea.json",
      "./South_Sudan.json",
      "./Spain.json",
      "./Sri_Lanka.json",
      "./Sudan.json",
      "./Suriname.json",
      "./Swaziland.json",
      "./Sweden.json",
      "./Syria.json",
      "./Tajikistan.json",
      "./Tanzania.json",
      "./Thailand.json",
      "./The_Bahamas.json",
      "./The_Gambia.json",
      "./The_Netherlands.json",
      "./Togo.json",
      "./Tokelau.json",
      "./Tonga.json",
      "./Trinidad_and_Tobago.json",
      "./Tunisia.json",
      "./Turkey.json",
      "./Turkmenistan.json",
      "./Turks_and_Caicos_Islands.json",
      "./Tuvalu.json",
      "./Uganda.json",
      "./Ukraine.json",
      "./United_Arab_Emirates.json",
      "./United_Kingdom.json",
      "./United_States.json",
      "./Uruguay.json",
      "./Uzbekistan.json",
      "./Vanuatu.json",
      "./Vatican_City.json",
      "./Venezuela.json",
      "./Vietnam.json",
      "./Yemen.json",
      "./Zambia.json",
      "./Zimbabwe.json",
      "./world.json"
  ].map(fileName => fileName.split('.json')[0].slice(2))
    // 获取所有json文件
    // let mapJson = require.context(`./worldJSON`, true, /\.json$/)
    console.log(window.location)
    const publicPath = window.location.origin + '/map/'
    let map = {}
    if (callback) {
      axios({
        url: `${publicPath}worldJSON/${type}.json`,
        method: 'get',
      }).then((res) => {
        console.log(res.data)
        map[type] = res.data
        console.log(type, map[type])
        echarts.registerMap(type, map[type])
      })
      callback()
    } else {
      if (keys.includes(typeTranfrom)) {
        if (!map[typeTranfrom]) {
          axios({
            url: `${publicPath}worldJSON/${typeTranfrom}.json`,
            method: 'get',
          }).then((res) => {
            const comp = res.data
            map[typeTranfrom] = comp
          // 如果没有下级则返回
          if (!map[typeTranfrom]) {
            // log('no next')
            return 0;
          }
          if (!echarts) {
              log('ECharts is not Loaded');
              return 0;
          }
          if (!echarts.registerMap) {
              log('ECharts Map is not loaded');
              return 0;
          }
          echarts.registerMap(type, map[typeTranfrom])
        })
        } else {
          echarts.registerMap(type, map[typeTranfrom])
        }
      } else {
        return 0
      }
    }
    

}
